import { useMemo } from "react";

import TableSimple from "ds/components/TableSimple";
import { RepoFile } from "types/generated";

import buildFileTree, { getFileTreeLevel } from "../../fileTreeHelpers";
import useFilesTableStore from "./useFilesTableStore";
import useFilesNavigation from "./useFilesNavigation";
import { SPACELIFT_VCS_REPO_FILES_CELLS } from "./Cells";

type SpaceliftVcsRepoFilesTableProps = {
  files: RepoFile[];
  loading: boolean;
};

const SpaceliftVcsRepoFilesTable = ({ files, loading }: SpaceliftVcsRepoFilesTableProps) => {
  const { folderPathSegments } = useFilesNavigation();

  const tree = useMemo(() => buildFileTree(files), [files]);

  const currentItems = useMemo(() => {
    const items = getFileTreeLevel(tree, folderPathSegments);

    if (folderPathSegments.length > 0) {
      return [
        { name: "..", path: "__parent__", type: "parent" as const, children: [], siblingCount: 0 },
        ...items,
      ];
    }

    return items;
  }, [tree, folderPathSegments]);

  return (
    <>
      <TableSimple
        data={currentItems}
        store={useFilesTableStore}
        ariaLabel="Repository files"
        cellPerColumn={SPACELIFT_VCS_REPO_FILES_CELLS}
        loading={loading}
        itemIdKey="path"
        virtualize={currentItems.length > 50}
      />
    </>
  );
};

export default SpaceliftVcsRepoFilesTable;
